import type { IModuleDefinition } from '@platform/core/types';

const definitions = new Map<string, IModuleDefinition>();

/** Визначення модулів із файлів пакетів (definition/, pages/), зареєстровані під час loadModule. */
export function registerModuleDefinition(moduleKey: string, definition: IModuleDefinition): void {
  definitions.set(moduleKey, definition);
}

export function findModuleDefinition(moduleKey: string): IModuleDefinition | undefined {
  return definitions.get(moduleKey);
}
